export default __webpack_public_path__ + "static/birdeye-fbf7c0246f6f673a72589829101764e2.svg";